// @flow
import React from 'react';
import styled from 'styled-components';
import { Small } from '@finect/tabular-core/Small';
import { Tooltip } from '@finect/tabular-components/Tooltip';
import { timeSince } from '@finect/front-utils/timeSince';

/* eslint-disable */
const PublicationDate = styled(Small)`
  display: block;
  position: relative;
  padding-top: 9px;
  margin-bottom: 6px;

  &:before {
    position: absolute;
    top: 0;
    left: 0;
    width: 24px;
    height: 1px;
    content: '';
    background-color: ${({ theme }) => theme.borderColor};
  }

  a {
    color: ${({ theme }) => theme.colors.fontL};

    &:hover {
      text-decoration: underline;
    }
  }

  svg {
    position: relative;
    top: 3px;
    margin-right: 3px;
  }
`;
/* eslint-enable */

type Props = {
  publishDate: string,
  lastRevision?: string,
  anchor: string
};

export const EntryPublication = ({ publishDate, lastRevision, anchor }: Props) => {
  const publicationDate = timeSince(new Date(publishDate));
  const revisionDate = lastRevision ? new Date(lastRevision).toLocaleDateString('es-ES') : null;

  return (
    <PublicationDate light>
      Publicado {anchor ? <a href={anchor}>{publicationDate}</a> : publicationDate}
      {lastRevision ? (
        <Tooltip tip={`Ultima revisión ${timeSince(new Date(lastRevision))}`}> (editado {revisionDate})</Tooltip>
      ) : null}
    </PublicationDate>
  );
};
